import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { iamMessages } from '../../config';
import { appActions, userActions, validationActions, iamThunk } from '../../actions';
import PageBoilerplateDefault from '../../components/page/PageBoilerplateDefault';
import { Validation, Intl } from '../../mixins';
import { getRecoverableErrorType } from '../../reducers';
import { setRoute, path } from '../../router';
import {
	DNAInputWithLabel,
	DNAButtonSocial,
	DNAHeadingH1,
	DNAValidationMessage,
	Avatar,
	DNAButtonContinue,
	FootnoteTsAndCs,
} from '../../components';

@Validation
export class RegisterPage extends Component {
	static propTypes = {
		updateRoute: PropTypes.func,
		requestSettings: PropTypes.object.isRequired,
		registerPageHeading1: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string,
		]),
		isAppDisabled: PropTypes.bool,
		iamRequestInFlight: PropTypes.bool,
		loginSuccessCallback: PropTypes.func,
		registerPageContinueButtonLabel: PropTypes.string,
		globalAlertsDecoratorClass: PropTypes.string,
		mainClassName: PropTypes.string,
		emailAddress: PropTypes.string,
		password: PropTypes.string,
		firstName: PropTypes.string,
		lastName: PropTypes.string,
		appActions: PropTypes.object,
		userActions: PropTypes.object.isRequired,
		iamThunk: PropTypes.object.isRequired,
		iamRequestError: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
		]),
		// HOCs
		intl: PropTypes.object.isRequired,
		router: PropTypes.object,
		// Decorators
		errors: React.PropTypes.object,
		propsFromHost: React.PropTypes.object,
	};
	static defaultProps = {
		errors: {},
		propsFromHost: {},
	};
	constructor(props) {
		super(props);

		// Clear existing alerts
		this.state = {
			alertRegisterError: false,
		};

		// Register which fields on the page expected validation
		this.validatedFields = [
			'emailAddress',
			'firstName',
			'lastName',
			'password',
		];
	}
	componentWillMount() {
		const { userActions } = this.props;
		// Clear password field
		userActions.updatePassword('');

		this.validatedFields.forEach(field => {
			this.hasErrors(field) && this.clearValidation(field);
		});
	}
	componentDidMount() {
		const { propsFromHost } = this.props;

		if (propsFromHost.onRegisterPageMount) {
			propsFromHost.onRegisterPageMount();
		}
	}
	handleFieldChange(action, e) {
		const { userActions } = this.props;
		userActions[action] && userActions[action](e.target.value);
	}
	handleFieldBlur(e) {
		this.validate(e.target.id, e.target.value);
	}
	handleSubmit(e) {
		const { emailAddress, firstName, lastName, password, propsFromHost } = this.props;

		if (propsFromHost.onRegisterPageSubmitClicked) {
			propsFromHost.onRegisterPageSubmitClicked();
		}

		e && e.preventDefault();
		([
			this.isValid('emailAddress', emailAddress),
			this.isValid('firstName', firstName),
			this.isValid('lastName', lastName),
			this.isValid('password', password),
		].every(isValid => isValid)) && this.proceed();
	}
	registerAndLoginWithIam() {
		const {
			iamThunk,
			loginSuccessCallback,
		} = this.props;

		// Clear existing error alerts
		this.setState({
			alertRegisterError: false,
		});

		iamThunk.iamRegisterAndLogin()
			.then(loginSuccessCallback)
			.catch(error => {
				// Show latest register error alerts
				this.setState({
					alertRegisterError: true,
				});
			});
	}
	proceed() {
		this.registerAndLoginWithIam();
	}
	routeTo(e, route) {
		e.preventDefault();
		const { updateRoute, router, publicPath } = this.props;
		setRoute(updateRoute, router)(path.join(publicPath, route));
	}
	getRecoverableError() {
		let {
			iamRequestError,
			intl,
		} = this.props;
		const { alertRegisterError } = this.state;

		if (iamRequestError === iamMessages.EMAIL_ADDRESS_IN_USE.error) {
			iamRequestError = {
				intlKey: iamMessages.EMAIL_ADDRESS_IN_USE.error,
				link: () => {
					return (
						<a
							href='#'
							data-qa='linkToPasswordPage'
							className='dna-text-link'
							onClick={ e => ::this.routeTo(e, 'password')}>
							{intl.formatMessage('content|login:register|loginAlertLinkText')}
						</a>
					);
				},
			};
		}

		return alertRegisterError && iamRequestError;
	}
	render() {
		const {
			intl,
			errors,
			mainClassName,
			emailAddress,
			password,
			firstName,
			lastName,
			registerPageHeading1,
			registerPageContinueButtonLabel,
			iamRequestInFlight,
			globalAlertsDecoratorClass,
			isAppDisabled,
		} = this.props;

		const isFormButtonDisabled = !::this.isEveryValid() || isAppDisabled || iamRequestInFlight;

		return (
			<PageBoilerplateDefault
				intl={intl}
				globalAlertsDecoratorClass={globalAlertsDecoratorClass}
				isRecoverableError={::this.getRecoverableError()}
				HeadingH1Content={registerPageHeading1}
				mainClassName={mainClassName}
				handleSubmit={::this.handleSubmit}>

				<Avatar decoratorClass='dna-space-mtm' />

				<DNAInputWithLabel
					intl={intl}
					parent={this}
					type='email'
					value={emailAddress}
					handleBlur={::this.handleFieldBlur}
					handleChangeProp={
						(e) => {
							::this.handleFieldChange('updateEmailAddress', e);
							::this.handleFieldBlur(e);
						}
					}
					id='emailAddress'
					label={intl.formatMessage('content|login:email|emailFieldLabel')}
					sizeVariant='medium'
					errors={errors.emailAddress} />

				<DNAValidationMessage
					intl={intl}
					wrapperClass='login-validation-message'
					fieldName='emailAddress'
					errors={[...errors.emailAddress || []]} />

				<div className='dna-form-field-distribute'>
					<DNAInputWithLabel
						intl={intl}
						parent={this}
						errorKey='firstName'
						value={firstName}
						handleBlur={::this.handleFieldBlur}
						handleChangeProp={
							(e) => {
								::this.handleFieldChange('updateFirstName', e);
								::this.handleFieldBlur(e);
							}
						}
						id='firstName'
						label={intl.formatMessage('content|login:register|firstNameFieldLabel')}
						sizeVariant='medium'
						errors={errors.firstName} />

					<DNAInputWithLabel
						intl={intl}
						parent={this}
						errorKey='lastName'
						value={lastName}
						handleBlur={::this.handleFieldBlur}
						handleChangeProp={
							(e) => {
								::this.handleFieldChange('updateLastName', e);
								::this.handleFieldBlur(e);
							}
						}
						id='lastName'
						label={intl.formatMessage('content|login:register|lastNameFieldLabel')}
						sizeVariant='medium'
						errors={errors.lastName} />
				</div>

				<DNAValidationMessage
					intl={intl}
					wrapperClass='login-validation-message'
					fieldName='firstName_lastName'
					errors={[...errors.firstName || [], ...errors.lastName || []]} />

				<DNAInputWithLabel
					parent={this}
					errorKey='password'
					isPasswordField={true}
					type='password'
					value={password}
					toggleButtonTextHide={intl.formatMessage('content|login:password|passwordFieldHintLabelHide')}
					toggleButtonTextShow={intl.formatMessage('content|login:password|passwordFieldHintLabelShow')}
					id='password'
					handleBlur={::this.handleFieldBlur}
					label={intl.formatMessage('content|login:register|passwordFieldLabel')}
					handleChangeProp={e => ::this.handleFieldChange('updatePassword', e)}
					sizeVariant='medium'
					errors={errors.password} />

				<DNAValidationMessage
					intl={intl}
					wrapperClass='login-validation-message'
					fieldName='password'
					errors={[...errors.password || []]} />

				<DNAButtonContinue
					type='submit'
					intl={intl}
					wrapperDecoratorClass='dna-space-mtxl'
					handleContinueProp={e => ::this.handleSubmit(e)}
					buttonText={registerPageContinueButtonLabel ?
						registerPageContinueButtonLabel :
						intl.formatMessage('content|login:register|defaultContinueButtonLabel')}
					buttonState={iamRequestInFlight ? 'loading' : ''}
					showDisabled={isFormButtonDisabled}
					isDisabled={isFormButtonDisabled}
					qaSelector='registerContinueButton' />

				<FootnoteTsAndCs
					intl={intl} />

			</PageBoilerplateDefault>
		);
	}
}

export const mapStateToProps = state => {
	const iamRequestInFlight = state.HTTP_request.iam_register && state.HTTP_request.iam_register.isInflight ? true : false;

	return {
		emailAddress: state.emailAddress || '',
		firstName: state.firstName || '',
		lastName: state.lastName || '',
		password: state.password || '',
		errors: state.VALIDATION_errors,
		iamRequestInFlight,
		iamRequestError: getRecoverableErrorType(state, 'iam_register',  state.APP_network),
		propsFromHost: state.propsFromHost,
	};
};

const mapDispatchToProps = dispatch => ({
	appActions: bindActionCreators(appActions, dispatch),
	userActions: bindActionCreators(userActions, dispatch),
	validationActions: bindActionCreators(validationActions, dispatch),
	iamThunk: bindActionCreators(iamThunk, dispatch),
});

const RegisterPageComposed = Intl(RegisterPage);
export const RegisterPageWithRouter = connect(mapStateToProps, mapDispatchToProps)(withRouter(RegisterPageComposed));
export default connect(mapStateToProps, mapDispatchToProps)(RegisterPageComposed);



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/containers/pages/RegisterPage.js